export default "__VITE_ASSET__C_pey8uE__"